// Native scroll-snap handles movement; JS only loads the optional image and guards swipe clicks.
if (!customElements.get('product-card-images')) {
  customElements.define('product-card-images', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const on = (target, type, callback, options = {}) => target.addEventListener(type, callback, { ...options, signal: this.events.signal });
      const touch = matchMedia('(max-width: 760px), (pointer: coarse), (hover: none)');
      const enable = () => {
        this.observer?.disconnect();
        this.toggleAttribute('data-swipe', touch.matches);
        if (!touch.matches) { this.scrollLeft = 0; return; }
        if (this.children.length > 2) return;
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          const template = this.querySelector('template');
          if (template) { this.append(template.content.cloneNode(true)); template.remove(); }
          this.observer.disconnect();
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      };
      on(touch, 'change', enable);
      on(this, 'pointerdown', event => {
        this.start = { x: event.clientX, y: event.clientY, scroll: this.scrollLeft };
        this.swiped = false;
      }, { passive: true });
      on(this, 'pointermove', event => {
        if (this.start && Math.hypot(event.clientX - this.start.x, event.clientY - this.start.y) > 10) this.swiped = true;
      }, { passive: true });
      on(this, 'scroll', () => {
        if (this.start && Math.abs(this.scrollLeft - this.start.scroll) > 10) this.swiped = true;
      }, { passive: true });
      on(this, 'click', event => {
        if (this.hasAttribute('data-swipe') && event.detail && this.swiped) { event.preventDefault(); event.stopPropagation(); }
        this.start = null;
      }, { capture: true });
      enable();
    }
    disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); }
  });
}
